import activate from "./activate";

const reducers = {
  activate,
};

export default reducers;
